import { useUser } from "hooks/user/useUser";
import { UserType } from "types/users";

export function useIsUserSciduck(): boolean {
  const user = useUser();
  const customerType = user.userprofile.customer_type;

  if (!customerType) {
    return false;
  }

  return customerType === UserType.Groundlight;
}
